import { __rest } from "tslib";
import * as React from "react";
import { Tag } from "lucide-react";
import { cn } from "../../lib/utils";
{
}
/**
 * @example
 *
 * ```jsx
 * import { TagItem } from "@skve/components"
 *
 * function Demo() {
 *   return <TagItem>Tag</TagItem>
 * }
 * ```
 */
export const TagItem = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (React.createElement("span", Object.assign({ className: cn("px-2 py-1 bg-red-200 text-red-800 rounded-md", className) }, props),
        React.createElement(Tag, { className: "w-4 h-4 inline-block mr-1" }),
        children));
};
//# sourceMappingURL=tag-item.js.map